import injectSheet from 'react-jss'
import SeatTradeMenu from './SeatTradeMenu'
import styles from './SeatTradeMenu.styles'

export default injectSheet(styles)(SeatTradeMenu)
